export default "__VITE_ASSET__qYzq1prX__"